import { UserTypeEnum } from '~/models';
import type { ICreateUserApiPayload, ICreateUserApiResponse } from '../types/SignUp.api';
import type { ISignUpRequest, ISignUpResponse } from '../types/SignUp';

const SOURCE = 'web-portal';

/**
 * One decision point for whether a signup carries a referral (GOTU-7435):
 *
 * | flag | referral field        | userType |
 * |------|-----------------------|----------|
 * | off  | none                  | absent   |
 * | on   | `referredByCode` (v2) | `DNT`    |
 *
 * The flag arrives on the request, captured once at the start of the flow, so
 * a mid-flow flip cannot change the payload of a submission in progress. The
 * legacy `referralID` path is gone (GOTU-7165): with the flag off a signup is
 * simply unreferred.
 */
const toCreateUserPayload = (input: ISignUpRequest): ICreateUserApiPayload => {
  const base = { email: input.email, password: input.password, source: SOURCE };

  if (input.isReferralRebuildEnabled) {
    return {
      ...base,
      userType: UserTypeEnum.DNT,
      ...(input.referredByCode ? { referredByCode: input.referredByCode } : {}),
    };
  }

  return base;
};

const toSignUpResponse = (apiResponse: ICreateUserApiResponse): ISignUpResponse => ({
  access_token: apiResponse.accessToken,
  refresh_token: apiResponse.refreshToken,
  expires_in: String(apiResponse.expiresIn),
});

export const SignUpAdapters = {
  toCreateUserPayload,
  toSignUpResponse,
};
